RivalIQ.apps.Discovery.module('views', function (views, App, Backbone, Marionette, $, _) {

    'use strict';

    const MAX_TITLE_LENGTH = 150;

    views.InfluencerProfileTableCell = Marionette.LayoutView.mixin({
        tagName: 'td',
        className: 'post-overview discovery-table-cell',
        template: '#influencerProfileTableCellTemplate',

        ui: {
            noOverviewText: '.x-influencer-no-overview'
        },

        regions: {
            description: '.x-linkified-text'
        },

        onRender: function () {
            const me = this;
            me.showUserOverview();
            me.showLinkifiedText();
        },

        showLinkifiedText: function () {
            const me = this;
            const user = _.last(me.getOption('data'));
            me.description.show(new views.LinkifiedText({
                model: me.model,
                data: {
                    text: user.overview,
                    urls: user.extractedUrls
                }
            }));
        },

        showUserOverview: function () {
            const me = this;

            const user = _.last(me.getOption('data'));
            if (_.trim(user.overview).length === 0) {
                me.ui.noOverviewText.show();
            }
        },

        serializeData: function () {
            const me = this;
            const user = _.last(me.getOption('data'));
            const channel = me.model.get('channel');

            const dashboardModel = me.getOption('table').dashboardModel;
            const postWord = RivalIQ.data.channels.get(dashboardModel.getProp('channel')).get('postName');

            const filterDimension = 'postAuthor';
            const newFilterTerm = user.handle;
            const filterLink = App.utils.getFilterUrl(filterDimension, newFilterTerm, me.getOption('table'));

            const analyzeAccountUrl = App.utils.getAnalyzeAccountUrl(dashboardModel, user.handle);

            return _.extend({
                maxTitleLength: MAX_TITLE_LENGTH,
                following: false,
                verified: null,
                postWord: postWord,
                filterLink: filterLink,
                filterDimension: filterDimension,
                filterValue: newFilterTerm,
                user: user,
                analyzeAccountUrl: analyzeAccountUrl
            }, App.utils.generateProfileLinks(user.handle, channel), user);
        },

        templateHelpers: function () {
            return RivalIQ.utils.emoji.getTemplateHelpers();
        }
    });

    views.InfluencerScoreTableCell = Marionette.ItemView.extend({
        tagName: 'td',
        className: 'metric-table-cell influencer-score',
        template: '#influencerScoreTableCellTemplate',

        serializeData: function () {
            const me = this;
            const influencerScore = _.last(me.getOption('data'));
            return {
                segment: App.utils.getInfluencerScoreSegment(influencerScore),
                segmentCount: App.utils.SEGMENT_COUNT
            };
        }
    });

});
